export const selectDonationsLoading = (state) => state?.donations?.loading;
export const selectDonationsData = (state) => state?.donations?.donationsData;
